module.exports = __webpack_public_path__ + "static/img/19.ec21cdd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/zh/19.png
// module id = 3+sk
// module chunks = 0